export default "__VITE_ASSET__DVg6OdEp__"